/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { checkmark } from "../assets/checkmark";
import { Icon, type IconBaseProps } from "../icon";

export const IconCheckmark = (props: IconBaseProps) => <Icon {...props} svg={checkmark} />;

IconCheckmark.displayName = "IconCheckmark";
